import config from "@/config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

 const sidebarService = {
  getSidenav: async () => {
    return serviceInstance
      .get(`${config.baseurl}/Role/Admin/Module`)
      .then(({ data }) => data);
  },

  getUserModule: async () => {
    return serviceInstance
      .get(`${config.baseurl}/Role/Admin/Users-RoleModules`)
      .then(({ data }) => data);
  },
};
export default sidebarService
